<!-- 编辑商品 -->

<template>
  <a-modal v-model:visible="visible" :title="title" :maskClosable="false" width="1200px">
    <template #footer>
      <a-button key="back" @click="handleCancel">关闭</a-button>
    </template>

    <Table :info="tableInfo" @changePage="changePage" @selectChange="selectChange($event)">
      <!-- <template #title="{ record }">
        <div v-if="record" class="good_info">
          <img class="good_img" :src="record.imgUrl" alt="" />
          <div class="good_text">
            <div class="good_goto" @click="gotoGoods(record)">
              {{ record.title }}
            </div>
            <div>商品ID：{{ record.itemId }}</div>
          </div>
        </div>
      </template> -->
      <template #SKU="{ record }">
        <div v-if="record" class="good_info2">
          {{ record.SkuId }}
        </div>
      </template>
      <template #SPU>
        <div class="good_info">
          {{ item.ItemId }}
        </div>
      </template>
      <template #SPU_Name>
        <div class="good_info">
          {{ item.Title }}
        </div>
      </template>
      <template #img="{ record }">
        <div class="good_info">
          <img
            v-if="record.SpecProps && record.SpecProps[0]"
            class="good_img"
            :src="record.SpecProps[0].ImgUrl"
            alt=""
          />
        </div>
      </template>

      <template #SKU_Name="{ record }">
        <div class="good_info2">
          {{ record.ExtInfos.SkuName }}
        </div>
      </template>
      <template #price="{ record }">
        <div class="good_info2">
          {{ (record.Price / 100).toFixed(2) }}
        </div>
      </template>
      <template #stock="{ record }">
        <div class="good_info2">
          {{ record.Stock }}
        </div>
      </template>
    </Table>
  </a-modal>
</template>

<script>
import { getProductInfo } from "../../good_manage_api";
export default {
  components: {},
  data() {
    return {
      title: "",
      item: {},
      visible: false,
      tableInfo: {
        page: 1,
        pageSize: 10000,
        showTotal: (total) => `共 ${total} 条`,
        hideOnSinglePage: true,
        pageSizeOptions: ["20", "50", "100"],
        list: [],
        total: 0,
        tableScroll: { x: "800px", y: "calc(100vh - 430px)" },
        loading: false,
        columns: [
          {
            title: "SKU",

            slots: { customRender: "SKU" },
          },
          {
            title: "SPU",

            slots: { customRender: "SPU" },
          },

          {
            title: "SPU名称",

            slots: { customRender: "SPU_Name" },
          },
          {
            title: "商品图片",
            width: 85,
            slots: { customRender: "img" },
          },
          {
            title: "SKU名称",

            slots: { customRender: "SKU_Name" },
          },
          {
            title: "销售价",

            slots: { customRender: "price" },
          },
          {
            title: "库存",

            slots: { customRender: "stock" },
          },
        ],
        rowSelection: null,

        renderSlot: ["SKU", "SPU", "SPU_Name", "img", "SKU_Name", "price", "stock"],
        rowKey: null,
      },
    };
  },
  methods: {
    //入口
    open(item) {
      this.queryParams = { title: "", itemId: "" };
      this.item = item;
      this.getGoodsData();
      this.visible = true;
    },

    //关闭方法
    handleCancel() {
      this.visible = false;
    },
    //获取商品数据
    getGoodsData() {
      this.tableInfo.loading = true;
      const query = {
        itemId: this.item.ItemId,
      };
      getProductInfo(query)
        .then((res) => {
          this.tableInfo.list = res.result.SkuList;
          // this.tableInfo.total = res.result.TotalNum;
          this.tableInfo.loading = false;
        })
        .catch(() => {
          this.tableInfo.loading = false;
        });
    },

    //切换分页配置
    changePage(page, size) {
      this.tableInfo.page = page;
      this.tableInfo.pageSize = size;
      this.getGoodsData();
    },
    //搜索
    search(itemId) {
      itemId && (this.queryParams.itemId = itemId);
      this.queryParams.itemId && (this.queryParams.itemId = this.queryParams.itemId.replace(/\s/g, ""));
      this.getGoodsData();
    },
    //选中
    selectChange(e) {
      console.log(e);
      console.log(this.tableInfo.selectedRowKeys);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.goods_header {
  display: flex;
  .header_item {
    margin-right: 10px;
  }
}
.good_info2 {
  text-align: center;
}
.good_info {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .good_img {
    width: 75px;
    height: 75px;
  }
  .good_text {
    text-align: left;
    cursor: pointer;
    .good_goto {
      color: #007fff;
    }
  }
}
</style>
